<template>
  <div class="cabinet-card leads-card">
    <h2 class="cabinet-card__title">Заявки з Платформи</h2>
    <p class="leads-card__lead">
      Клієнти, які записалися до вас кнопкою «Записатися» на вашій анкеті. Після розмови позначте результат: так ми бачимо, скільки консультацій дає Платформа.
    </p>
    <v-skeleton-loader v-if="loading" type="list-item-two-line@2"></v-skeleton-loader>
    <p v-else-if="!items.length" class="leads-card__empty">Заявок поки немає.</p>
    <div v-else class="leads-card__list">
      <div v-for="item in items" :key="item.id" class="leads-card__item">
        <div class="leads-card__info">
          <div class="leads-card__name">{{ item.name }}</div>
          <div class="leads-card__contacts">
            <a :href="'tel:' + item.phone">{{ item.phone }}</a><template v-if="item.email">, <a :href="'mailto:' + item.email">{{ item.email }}</a></template>
          </div>
          <div v-if="item.topic" class="leads-card__topic">{{ item.topic }}</div>
          <div class="leads-card__date">{{ formatDate(item.created_at) }}</div>
        </div>
        <v-select
          :value="item.status === 'new' ? null : item.status"
          :items="statuses"
          placeholder="Позначити результат"
          outlined
          dense
          hide-details
          class="leads-card__status"
          :menu-props="{ offsetY: true }"
          :loading="savingId === item.id"
          @change="save(item, $event)"
        ></v-select>
      </div>
    </div>
  </div>
</template>

<script>
import ApiClient from "@/libs/http-client";

export default {
  name: "LeadsCard",
  data() {
    return {
      items: [],
      loading: true,
      savingId: null,
      statuses: [
        { value: "contacted", text: "Зв'язався" },
        { value: "scheduled", text: "Консультацію призначено" },
        { value: "unreachable", text: "Не вдалося зв'язатися" },
      ],
    };
  },
  mounted() {
    ApiClient.get("api/psychologists/me/leads")
      .then((response) => {
        if (response) this.items = response.data.data;
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    save(item, status) {
      if (!status) return;
      this.savingId = item.id;
      ApiClient.post(`api/psychologists/me/leads/${item.id}`, { status })
        .then((response) => {
          if (response) Object.assign(item, response.data.data);
        })
        .finally(() => {
          this.savingId = null;
        });
    },
    formatDate(value) {
      return new Date(value).toLocaleString("uk-UA", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
    },
  },
};
</script>

<style lang="scss" scoped>
.leads-card__lead,
.leads-card__empty {
  margin: 12px 0 0;
  color: #575756;
  font-size: 15px;
}
.leads-card__list {
  margin-top: 16px;
}
.leads-card__item {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px 20px;
  padding: 14px 0;
  border-top: 1px solid #E3EAF0;
}
.leads-card__info {
  flex: 1 1 260px;
  min-width: 0;
  color: #575756;
  word-break: break-word;
}
.leads-card__name {
  font-weight: 500;
}
.leads-card__contacts a {
  color: #00A3B7;
}
.leads-card__topic {
  margin-top: 4px;
  font-size: 14px;
}
.leads-card__date {
  margin-top: 4px;
  color: #8A8A8A;
  font-size: 13px;
}
.leads-card__status {
  flex: 0 1 260px;
  max-width: 100%;
}
</style>
